import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getAccessReportsByUser } from '../../services';
import { GetAccessReportResponse } from '../../services/AccessReports/types';

export function useAccessReportsById(
  userId: string,
  page: number,
  options: UseQueryOptions<GetAccessReportResponse, unknown> = {},
): UseQueryResult<GetAccessReportResponse, unknown> {
  return useQuery<GetAccessReportResponse, unknown>(
    ['accessReports', userId, page],
    () => getAccessReportsByUser(userId, page),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      ...options,
    },
  );
}
